__turbopack_context__.v({
  "viewport": "ha29HW_viewport",
});
